// DOMParser does not lay out detached HTML, so innerText can lose paragraph breaks.
export const emailTemplateText = (value = "") => {
  const document = new DOMParser().parseFromString(String(value), "text/html");
  document.querySelectorAll("script, style").forEach((node) => node.remove());
  document.querySelectorAll("br").forEach((node) => node.replaceWith("\n"));
  document.querySelectorAll("p, div, li, h1, h2, h3, blockquote").forEach((node) => node.append("\n\n"));
  return (document.body.textContent || "").replace(/\u00a0/g, " ").replace(/\n[ \t]+/g, "\n").replace(/\n{3,}/g, "\n\n").trim();
};
